module.exports = __webpack_public_path__ + "img/trade-cover-1.af8016ad.png";